import React, { useState } from 'react';

import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Typography,
    makeStyles
} from '@material-ui/core';

import DialogContext from './DialogContext';

const useStyles = makeStyles({
    container: {
        borderRadius: 8
    }
});

function DialogMensagem(
    {
        config,
        handleClose
    }
) {
    const classes = useStyles();

    return (
        <Dialog open={config.open}
            PaperProps={{ classes: { root: classes.container } }}>
            <DialogTitle>
                <Typography component='span'
                    variant='subtitle1'
                    color='primary'>
                    {config.title}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Typography component='span'>
                        {config.body}
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => { handleClose(config.onClickButtonOne) }}
                    color="primary"
                    autoFocus>
                    {config.titleButtonOne ? config.titleButtonOne : 'OK'}
                </Button>
                {
                    config.onClickButtonTwo &&
                    <Button onClick={() => { handleClose(config.onClickButtonTwo) }}>
                        {config.titleButtonTwo ? config.titleButtonTwo : 'Cancelar'}
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );
}

function DialogProvider(
    {
        children
    }
) {
    const initialState = {
        open: false,
        title: null,
        body: null,
        titleButtonOne: null,
        onClickButtonOne: null,
        titleButtonTwo: null,
        onClickButtonTwo: null
    };

    const [config, setConfig] = useState(initialState);

    const handleShow = (title,
        body,
        onClickButtonOne,
        titleButtonOne = null,
        onClickButtonTwo = null,
        titleButtonTwo = null
    ) => {
        setConfig({
            open: true,
            title,
            body,
            onClickButtonOne,
            titleButtonOne,
            onClickButtonTwo,
            titleButtonTwo
        });
    };

    const handleClose = (func) => {
        if (func)
            func();

        setConfig(initialState);
    };

    return (
        <>
            <DialogContext.Provider value={{ show: handleShow }}>
                {children}
            </DialogContext.Provider>
            <DialogMensagem config={config}
                handleClose={handleClose} />
        </>
    )
}

export default DialogProvider;